var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"custom-button",style:(_vm.combinedStyles),attrs:{"disabled":_vm.disabled},on:{"click":_vm.buttonAction}},[(_vm.buttonIcon)?_c('span',{class:_vm.buttonIcon}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }